import ConnectMarketplace from '../ConnectMarketplaceNew';
import ConnectKauflandForm, { createValidationSchema } from './ConnectKauflandForm';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import ConnectMarketplaceWizard, { ConnectMarketplaceWizardProps } from '../ConnectMarketplaceWizard';
import ConnectMarketplaceHeader from '../ConnectMarketplaceHeader';
import { MarketplaceRegion } from 'src/graphql/generated';
import { ConnectKauflandStepBloc } from './ConnectKauflandStepBloc';
import { ConnectMarketplaceWizardBloc } from '../ConnectMarketplaceWizardBloc';

interface ConnectKauflandOrchestratorProps {
    region: MarketplaceRegion;
    showWizardComponents: boolean;
}

export const ConnectKauflandOrchestrator: FunctionComponent<ConnectKauflandOrchestratorProps> = ({
    region,
    showWizardComponents,
}) => {
    const { t } = useTranslation();
    const parentBloc = new ConnectMarketplaceWizardBloc(1, region, t);
    const step1Bloc = new ConnectKauflandStepBloc(region, parentBloc, null, t);
    return (
        <ConnectKaufland
            region={region}
            bloc={parentBloc}
            stepBlocs={[step1Bloc]}
            i18nPrefix="connectKaufland"
            showWizardComponents={showWizardComponents}
        />
    );
};

const ConnectKaufland: FunctionComponent<ConnectMarketplaceWizardProps> = (props) => {
    const { t } = useTranslation();

    return (
        <ConnectMarketplaceWizard {...props}>
            <ConnectMarketplace
                header={ConnectMarketplaceHeader}
                form={ConnectKauflandForm}
                validationSchema={createValidationSchema(t)}
            />
        </ConnectMarketplaceWizard>
    );
};
export default ConnectKaufland;
